<template>
    <div
        style="display: -ms-flexbox;
            display: flex;
            -ms-flex-direction: column;
            flex-direction: column;
            -ms-flex: 1;
            flex: 1;
            height: 100%;
            overflow: hidden;"
    >
        <limitless-page-top v-if="!config.popup">
            <template #content>
                <span v-if="hasRole('super-admin') && app.env && app.env !== 'production'" class="navbar-text ml-md-3">
                    <a href="/dev/toggle-cookie/livereadmode">
                        <span class="badge font-size-xs" :class="{ 'bg-warning' : app.liveread_mode }">
                            <span><i class="icon-database font-size-xs text-white"></i></span> LIVEREAD
                        </span>
                    </a>
                </span>
                <span v-if="hasRole('super-admin')" class="navbar-text ml-md-3">
                    <a href="/dev/toggle-cookie/debug">
                        <span class="badge font-size-xs" :class="{ 'bg-pink' : app.debug_mode }">
                            <span><i class="icon-wrench font-size-xs text-white"></i></span> DEBUGMODE
                        </span>
                    </a>
                </span>
            </template>
            <template #content-navbar>
                <li class="navbar-text" style="padding: 5px 10px;">
                    <form method="GET" action="/customers">
                        <input type="text" class="form-control input-xs" placeholder="Sök kund..." name="search" value="">
                    </form>
                </li>
                <li class="navbar-text" style="padding: 5px 10px;">
                    <form method="GET" action="/cardorders">
                        <input type="text" class="form-control input-xs" placeholder="Sök order..." name="search" value="">
                    </form>
                </li>
                <li class="navbar-text" style="padding: 5px 10px;">
                    <form method="GET" action="/prodorders">
                        <input type="text" class="form-control input-xs" placeholder="Sök kort..." name="search" value="">
                    </form>
                </li>
                <li class="navbar-text" style="padding: 5px 10px;">
                    <form method="GET" action="/products">
                        <input type="text" class="form-control input-xs" placeholder="Sök produkt..." name="search" value="">
                    </form>
                </li>
            </template>
            <template #user-navbar>
                <limitless-page-top-notifications-dropdown></limitless-page-top-notifications-dropdown>
            </template>
        </limitless-page-top>

        <!-- Page content -->
        <div class="page-content">
            <limitless-page-sidebar v-if="!config.popup">
                <template #footer>
                    <div class="font-size-sm">
                        Supekort Sweden AB<br>
                        Box 91<br>
                        601 02 Norrköping<br>
                        Tel 011-12 92 50<br>
                        Fax 011-16 73 50<br>
                        Orgnr 556571-2865<br>
                        info@supekort.se<br>
                    </div>
                    <div class="py-5 font-size-sm text-center">
                        <a onclick="window.open('/door','doorcontrol','width=850,height=700')" class="mt-20 btn btn-sm btn-light" target="doorcontrol">Dörrkontroll</a>
                    </div>
                    <div class="pb-5 font-size-sm text-center">
                        <a href="//get.teamviewer.com/ventiro" class="mt-20 btn btn-sm btn-light" target="_blank">Starta fjärrsupport</a>
                    </div>
                </template>
            </limitless-page-sidebar>

            <!-- Main content -->
            <div class="content-wrapper">

<!--                <limitless-page-header></limitless-page-header>-->

                <!-- Content area -->
<!--                <div class="content">-->
                    <child />
<!--                </div>-->
                <!-- /content area -->

                <limitless-page-footer></limitless-page-footer>

            </div>
            <!-- /main content -->

        </div>
        <!-- /page content -->
    </div>
</template>

<script>
import LimitlessPageTopNotificationsDropdown from '@components/Layout/partials/LimitlessPageTopNotificationsDropdown.vue';
import LimitlessPageFooter from '@components/Layout/partials/LimitlessPageFooter.vue';
import LimitlessPageSidebar from '@components/Layout/partials/LimitlessPageSidebar.vue';
// import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader.vue';
import LimitlessPageTop from '@components/Layout/partials/LimitlessPageTop.vue';
import { hasRole } from '@services/Helpers';
import { mapState } from 'pinia';
import Child from '@components/Layout/Child';
import { useLayoutHandlerStore } from '@services/pinia/LayoutHandlerStore';

export default {
    name: 'FullLayout',
    methods: {
        hasRole,
    },
    components: {
        LimitlessPageTopNotificationsDropdown,
        LimitlessPageFooter,
        // LimitlessPageHeader,
        LimitlessPageSidebar,
        LimitlessPageTop,
        Child,
    },
    computed: {
        ...mapState(useLayoutHandlerStore, ['app', 'config']),
    },
};
</script>
